import { createFileRoute, redirect } from "@tanstack/react-router"

export {
  VendorManagementColumn,
  type VendorRow,
} from "~/routes/_auth/procurement/vendor-management/_layout/vendors"

export const Route = createFileRoute("/_auth/procurement/vendor-management/")({
  loader: ({ location }) => {
    if (location.pathname === "/procurement/vendor-management") {
      throw redirect({ to: "/procurement/vendor-management/vendors" })
    }
    return null
  },
})
